import { useState } from 'react';
import { Link } from 'react-router-dom';
import JaLayout from '@/components/feature/JaLayout';
import useSEO from '@/hooks/useSEO';

const stats = [
  { value: '70%', label: 'リピート生産率' },
  { value: '250+', label: '提携ブランド数' },
  { value: '1600+', label: '処方データベース' },
  { value: '7', label: '対応剤型数' },
];

const products = [
  { name: 'マルチビタミンカプセル', category: 'ハードカプセル', img: 'https://readdy.ai/api/search-image?query=health%20supplement%20capsule%20bottle%20vitamin%20complex%20product%20on%20clean%20white%20background%2C%20professional%20commercial%20product%20photography%2C%20green%20label%2C%20minimalist%20style&width=400&height=400&seq=product-01&orientation=squarish' },
  { name: 'プロバイオティクス粉末', category: '粉末剤型', img: 'https://readdy.ai/api/search-image?query=probiotic%20powder%20sachet%20health%20supplement%20packet%20product%20on%20white%20background%2C%20clean%20professional%20product%20photography%2C%20green%20packaging%2C%20minimalist&width=400&height=400&seq=product-02&orientation=squarish' },
  { name: 'コラーゲンドリンク', category: '飲料剤型', img: 'https://readdy.ai/api/search-image?query=collagen%20drink%20bottle%20health%20beverage%20supplement%20on%20clean%20white%20background%2C%20professional%20commercial%20photography%2C%20elegant%20packaging%2C%20light%20green%20tones&width=400&height=400&seq=product-03&orientation=squarish' },
  { name: 'ハーブ植物錠剤', category: '錠剤剤型', img: 'https://readdy.ai/api/search-image?query=herbal%20plant%20extract%20tablet%20supplement%20bottle%20on%20white%20background%2C%20professional%20product%20photography%2C%20natural%20green%20packaging%2C%20clean%20minimal%20style&width=400&height=400&seq=product-04&orientation=squarish' },
  { name: 'フィッシュオイル軟カプセル', category: 'ソフトジェル', img: 'https://readdy.ai/api/search-image?query=fish%20oil%20omega3%20softgel%20capsule%20supplement%20bottle%20on%20white%20background%2C%20professional%20health%20product%20photography%2C%20clean%20minimal%20packaging%2C%20golden%20soft%20capsules%20visible&width=400&height=400&seq=product-05&orientation=squarish' },
];

const processSteps = [
  { step: '01', icon: 'ri-discuss-line', title: '初回ご相談', desc: '専門担当者と製品ニーズ・ターゲット市場・予算をご相談いただき、提携の方向性を確認します。' },
  { step: '02', icon: 'ri-draft-line', title: '処方のご提案', desc: 'R&Dチームがご要望に基づき、原料選定・機能訴求・法規確認を含む処方をご提案します。' },
  { step: '03', icon: 'ri-test-tube-line', title: 'サンプル製作', desc: '処方確定後、小ロットでサンプルを製作し、品質と風味をご確認いただきます。' },
  { step: '04', icon: 'ri-file-check-line', title: '量産確認', desc: 'サンプル承認後、契約締結・パッケージデザイン確定・生産スケジュールを調整し、量産に入ります。' },
  { step: '05', icon: 'ri-ship-line', title: '出荷・納品', desc: '品質検査完了後、予定スケジュールに従い出荷。完全な製品検査報告書をご提供します。' },
];

const testimonials = [
  {
    name: '陳様 ブランド創設者',
    company: 'ヘルシーミスターブランド',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20businessman%20portrait%20headshot%20confident%20smiling%2C%20clean%20white%20background%2C%20business%20casual%20attire%2C%2040s%20male&width=120&height=120&seq=avatar-01&orientation=squarish',
    quote: '康永生技のサポートでゼロからサプリメントブランドを立ち上げることができました。処方開発からパッケージデザインまで一貫してサポートしていただき、予定より2ヶ月早く発売できました。',
    rating: 5,
  },
  {
    name: '林様 製品マネージャー',
    company: 'ナチュラルオリジンブランド',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20businesswoman%20portrait%20headshot%20warm%20smiling%2C%20clean%20white%20background%2C%20business%20casual%20attire%2C%2035s%20female&width=120&height=120&seq=avatar-02&orientation=squarish',
    quote: '康永との取引は3年以上になります。品質は常に安定しており、法規書類の準備も非常に専門的で、海外展開の際に大変助かっています。',
    rating: 5,
  },
  {
    name: '王様 代表取締役',
    company: 'バイタルソース生技',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20executive%20manager%20portrait%20headshot%20serious%20confident%2C%20clean%20white%20background%2C%20formal%20business%20attire%2C%2050s%20male&width=120&height=120&seq=avatar-03&orientation=squarish',
    quote: '康永のR&Dチームは当社の市場ポジショニングをしっかり理解し、最適な処方を提案してくれます。真にクライアントファーストの製造パートナーです。',
    rating: 5,
  },
];

const faqs = [
  { q: '最小発注量（MOQ）はどのくらいですか？', a: 'MOQは剤型と処方の複雑さによって異なります。一般的なカプセル・錠剤製品は3,000〜5,000本からご対応しています。具体的な製品についてはお気軽にお問い合わせください。' },
  { q: 'カスタム処方の開発は可能ですか？', a: 'はい。康永生技は専任R&Dチームが在籍しており、お客様の機能要件・ターゲット層・市場ポジショニングに基づく完全カスタム処方の開発が可能です。' },
  { q: '処方確定から生産完了までどのくらいの期間がかかりますか？', a: '一般的に処方確定からサンプル完成まで2〜4週間、サンプル承認後の量産は注文規模によって4〜8週間程度かかります。' },
  { q: 'パッケージデザインサービスはありますか？', a: 'はい。ラベルデザインとパッケージコンサルティングを提供しています。お客様独自のデザインデータでの生産も対応可能です。担当者にご相談ください。' },
  { q: '台湾および輸出向けの法規制に対応していますか？', a: '台湾の健康食品法規を熟知し、豊富な輸出実績があります。製品の表示審査・法規申請のサポートにより、適法な市場投入をお手伝いします。' },
  { q: 'どのように始めればいいですか？', a: 'ウェブサイトのお問い合わせフォーム、電話、またはLINEでご連絡ください。担当者が1営業日以内にご返答し、詳細なニーズヒアリングを設定します。' },
];

export default function JaHomePage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  useSEO({
    title: '康永生技｜健康食品OEM/ODM製造サービス｜台湾',
    description: '康永生技は台湾の健康食品OEM/ODM専門メーカーです。処方開発からパッケージングまでワンストップで対応。HACCP認定工場、少ロット対応、輸出サポート。',
    keywords: '健康食品OEM 台湾, ODM製造, サプリメントOEM, HACCP認定工場, 康永生技',
    lang: 'ja',
    canonical: 'https://kangyong.com/ja',
  });

  return (
    <JaLayout>
      {/* Hero */}
      <section className="relative min-h-screen flex items-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=lush%20green%20nature%20botanical%20herbs%20plants%20background%20with%20soft%20light%20rays%20through%20leaves%2C%20fresh%20healthy%20organic%20feel%2C%20blurred%20background%20with%20vibrant%20green%20tones%2C%20minimalist%20clean%20aesthetic%20for%20biotech%20health%20supplement%20brand&width=1920&height=1080&seq=hero-kangyong-01&orientation=landscape"
            alt="康永生技 ヒーロー背景"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/55 via-black/30 to-black/10" />
        </div>
        <div className="relative z-10 w-full max-w-screen-xl mx-auto px-6 lg:px-10 py-28 pb-20 lg:py-0">
          <div className="max-w-2xl">
            <span className="inline-block bg-[#4CAF50]/20 border border-[#4CAF50]/50 text-[#7ed87f] text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-6 tracking-wide">
              OEM / ODM 専門製造サービス
            </span>
            <h1 className="text-white font-bold leading-tight mb-6">
              <span className="block text-[2rem] md:text-[2.75rem] leading-[1.25]">康永生技</span>
              <span className="block text-[2rem] md:text-[2.75rem] leading-[1.25]">OEM / ODM サービス</span>
              <span className="block text-[1.25rem] md:text-[1.625rem] font-medium text-green-300 mt-2">最も信頼できる製造パートナー</span>
            </h1>
            <p className="text-gray-200 text-[1.125rem] leading-[1.75] mb-10 max-w-xl">
              処方開発・製造・パッケージングから出荷まで、健康食品・生技製品のOEM/ODMをワンストップで提供。ブランドの迅速な市場投入をサポートします。
            </p>
            <div className="flex flex-col sm:flex-row flex-wrap gap-4">
              <Link to="/ja/contact/form" className="whitespace-nowrap bg-[#4CAF50] hover:bg-[#43a047] text-white font-semibold text-[1.0625rem] px-8 py-4 rounded-full transition-all duration-300 cursor-pointer">
                今すぐお問い合わせ
              </Link>
              <Link to="/ja/services" className="whitespace-nowrap bg-white/15 hover:bg-white/25 border border-white/60 text-white font-semibold text-[1.0625rem] px-8 py-4 rounded-full transition-all duration-300 cursor-pointer">
                サービス一覧を見る
              </Link>
            </div>
          </div>
        </div>
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 z-10 animate-bounce">
          <span className="text-white/50 text-[0.8125rem] tracking-widest">SCROLL</span>
          <i className="ri-arrow-down-line text-white/50 text-xl" />
        </div>
      </section>

      {/* Service Cards */}
      <section className="py-20 bg-white">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
          <div className="text-center mb-14">
            <span className="inline-block bg-green-50 text-[#4CAF50] text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-4 border border-green-200">
              サービス内容
            </span>
            <h2 className="text-[#1a2e1a] font-bold mb-4">OEM/ODM 製造サービス一覧</h2>
            <p className="text-gray-500 text-[1.0625rem] leading-[1.75] max-w-2xl mx-auto">
              康永生技は健康食品・生技製品の包括的なOEM/ODM製造サービスを提供し、ブランドの市場投入を全力でサポートします。
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { icon: 'ri-flask-line', title: '処方研究開発', desc: '専門R&Dチームが最新の生技原料と製造技術を組み合わせ、ご要望に沿った独自の処方を開発します。', tag: 'R&Dサービス', color: '#4CAF50' },
              { icon: 'ri-capsule-line', title: '生産製造', desc: 'HACCP基準に適合した工場で、各種剤型に対応。小ロット試作から大量量産まで柔軟に対応します。', tag: '製造サービス', color: '#66BB6A' },
              { icon: 'ri-award-line', title: '品質認証', desc: '複数の国際品質認証を取得。すべての製造工程を厳格に管理し、製品の安全性と品質の安定を保証します。', tag: '品質管理', color: '#81C784' },
              { icon: 'ri-truck-line', title: 'ワンストップサービス', desc: '原料調達・処方開発・生産製造・パッケージデザインまで、完全なOEM/ODMサービスをワンストップで提供します。', tag: 'フルサービス', color: '#A5D6A7' },
            ].map((s) => (
              <div key={s.title} className="bg-white border border-gray-100 rounded-2xl p-7 hover:border-green-200 hover:-translate-y-1 transition-all duration-300 cursor-default group">
                <div className="w-14 h-14 flex items-center justify-center rounded-xl mb-5" style={{ backgroundColor: `${s.color}20` }}>
                  <i className={`${s.icon} text-2xl`} style={{ color: s.color }} />
                </div>
                <span className="inline-block text-[0.75rem] font-medium px-3 py-1 rounded-full mb-3" style={{ backgroundColor: `${s.color}18`, color: s.color }}>{s.tag}</span>
                <h3 className="text-[#1a2e1a] font-bold text-[1.1875rem] mb-3">{s.title}</h3>
                <p className="text-gray-500 text-[0.9375rem] leading-[1.75]">{s.desc}</p>
              </div>
            ))}
          </div>
          <div className="text-center mt-10">
            <Link to="/ja/services" className="whitespace-nowrap inline-flex items-center gap-2 border border-[#4CAF50] text-[#4CAF50] hover:bg-[#4CAF50] hover:text-white font-semibold text-[1rem] px-8 py-3.5 rounded-full transition-all duration-300 cursor-pointer">
              すべてのサービスを見る
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </section>

      {/* About Preview */}
      <section className="py-20 bg-[#f7faf7]">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
          <div className="flex flex-col lg:flex-row items-center gap-14 lg:gap-20">
            <div className="w-full lg:w-1/2 flex-shrink-0">
              <div className="relative rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=professional%20biotech%20laboratory%20scientist%20researcher%20working%20with%20natural%20herb%20ingredients%20in%20modern%20clean%20lab%20environment%2C%20green%20plants%20bottles%20supplements%20on%20desk%2C%20bright%20natural%20lighting%2C%20high%20quality%20commercial%20photography%20for%20health%20food%20brand&width=720&height=540&seq=about-preview-01&orientation=landscape"
                  alt="康永生技 研究室"
                  className="w-full h-[260px] sm:h-[340px] lg:h-[440px] object-cover object-top rounded-2xl"
                />
                <div className="absolute bottom-6 left-6 bg-white rounded-xl px-5 py-4 flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-green-50 rounded-lg">
                    <i className="ri-shield-check-line text-[#4CAF50] text-xl" />
                  </div>
                  <div>
                    <p className="text-[#1a2e1a] font-bold text-[1rem]">HACCP認定工場</p>
                    <p className="text-gray-400 text-[0.8125rem]">国際基準に準拠した製造環境</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full lg:w-1/2">
              <span className="inline-block bg-green-50 text-[#4CAF50] text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-5 border border-green-200">康永について</span>
              <h2 className="text-[#1a2e1a] font-bold text-[1.875rem] md:text-[2.25rem] leading-tight mb-6">健康食品製造における最良のパートナー</h2>
              <p className="text-gray-600 text-[1.0625rem] leading-[1.75] mb-6">
                康永生技は長年にわたり健康食品・生技製品のOEM/ODM製造に特化してきました。充実したR&D・製造・品質管理体制で、ブランドのアイデアを市場製品へと実現します。
              </p>
              <p className="text-gray-600 text-[1.0625rem] leading-[1.75] mb-8">
                原料調達から完成品出荷まで、すべての工程を厳格に管理。法規に準拠した安全な市場投入をお約束します。
              </p>
              <div className="grid grid-cols-2 gap-5 mb-10">
                {[
                  { icon: 'ri-building-line', label: 'HACCP認定工場' },
                  { icon: 'ri-test-tube-line', label: '自社R&D研究室' },
                  { icon: 'ri-global-line', label: '専門代工サービス' },
                  { icon: 'ri-customer-service-line', label: '専任担当サポート' },
                ].map((item) => (
                  <div key={item.label} className="flex items-center gap-3">
                    <div className="w-9 h-9 flex items-center justify-center bg-green-50 rounded-lg flex-shrink-0">
                      <i className={`${item.icon} text-[#4CAF50] text-lg`} />
                    </div>
                    <span className="text-[#1a2e1a] font-medium text-[0.9375rem]">{item.label}</span>
                  </div>
                ))}
              </div>
              <Link to="/ja/about" className="whitespace-nowrap inline-flex items-center gap-2 bg-[#4CAF50] hover:bg-[#43a047] text-white font-semibold text-[1rem] px-8 py-4 rounded-full transition-all duration-300 cursor-pointer">
                詳細を見る <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="py-16 bg-[#2d5a2d]">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            {stats.map((stat) => (
              <div key={stat.label} className="text-center">
                <p className="text-white font-bold text-[2rem] md:text-[2.75rem] xl:text-[3.25rem] leading-none mb-2">{stat.value}</p>
                <p className="text-green-200 text-[1rem] leading-[1.75]">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Product Showcase */}
      <section className="py-20 bg-[#f7faf7]">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
          <div className="text-center mb-14">
            <span className="inline-block bg-green-50 text-[#4CAF50] text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-4 border border-green-200">製品サンプル</span>
            <h2 className="text-[#1a2e1a] font-bold text-[1.875rem] md:text-[2.25rem] mb-4">多様な剤型で市場ニーズに対応</h2>
            <p className="text-gray-500 text-[1.0625rem] leading-[1.75] max-w-2xl mx-auto">多彩な剤型をブランドのご要望に合わせてご提供。製品ラインナップの拡充をサポートします。</p>
          </div>
          <div className="flex flex-wrap justify-center gap-3 sm:gap-4">
            {products.map((p) => (
              <div
                key={p.name}
                className="w-[calc(50%-0.375rem)] sm:w-[calc(33.333%-0.667rem)] lg:w-[calc(20%-0.8rem)] bg-white rounded-2xl overflow-hidden border border-gray-100 hover:border-green-200 hover:-translate-y-1 transition-all duration-300 group cursor-default"
              >
                <div className="w-full h-[200px] sm:h-[220px] overflow-hidden">
                  <img src={p.img} alt={p.name} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300" />
                </div>
                <div className="p-3 text-center">
                  <span className="text-[#4CAF50] text-[0.75rem] font-medium">{p.category}</span>
                  <p className="text-[#1a2e1a] font-semibold text-[0.875rem] mt-1">{p.name}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Advantages Section */}
      <section className="py-20 bg-white">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
          <div className="text-center mb-14">
            <span className="inline-block bg-green-50 text-[#4CAF50] text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-4 border border-green-200">
              康永を選ぶ理由
            </span>
            <h2 className="text-[#1a2e1a] font-bold mb-4">6つのコアストレングス</h2>
            <p className="text-gray-500 text-[1.0625rem] leading-[1.75] max-w-2xl mx-auto">
              専門技術・厳格な品質管理・包括的なサービスで、多くのブランドから信頼される製造パートナーです。
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              { icon: 'ri-microscope-line', title: '専門R&Dチーム', desc: '食品科学・生技の深い知識を持つR&Dチームが最新の原料トレンドと処方技術を継続的に追求します。' },
              { icon: 'ri-verified-badge-line', title: '品質認証保証', desc: 'HACCP・ISOなど複数の国際品質認証を取得。各バッチに完全な品質検査報告書を発行します。' },
              { icon: 'ri-time-line', title: '短納期対応', desc: '最適化された生産スケジュール管理で、サンプル確認から量産までの期間を効率的に短縮します。' },
              { icon: 'ri-price-tag-3-line', title: '競争力のある価格', desc: '自社工場と直接調達により、品質とコストパフォーマンスの最適なバランスを実現します。' },
              { icon: 'ri-file-list-3-line', title: '法規申請サポート', desc: '台湾および各国の健康食品法規に精通しており、製品表示の確認および届出手続きをサポートします。' },
              { icon: 'ri-user-heart-line', title: '長期パートナーシップ', desc: 'アフターサービスのフォローアップと技術サポートを提供し、各クライアントと長期的で安定した提携関係を築きます。' },
            ].map((item) => (
              <div key={item.title} className="flex gap-5 p-6 rounded-2xl bg-[#f7faf7] hover:bg-green-50 border border-transparent hover:border-green-200 transition-all duration-300">
                <div className="w-12 h-12 flex items-center justify-center bg-white rounded-xl flex-shrink-0 border border-green-100">
                  <i className={`${item.icon} text-[#4CAF50] text-xl`} />
                </div>
                <div>
                  <h3 className="text-[#1a2e1a] font-bold text-[1.0625rem] mb-2">{item.title}</h3>
                  <p className="text-gray-500 text-[0.9375rem] leading-[1.75]">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process */}
      <section className="py-20 bg-white">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
          <div className="text-center mb-14">
            <span className="inline-block bg-green-50 text-[#4CAF50] text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-4 border border-green-200">提携フロー</span>
            <h2 className="text-[#1a2e1a] font-bold text-[1.875rem] md:text-[2.25rem] mb-4">5つのステップで提携スタート</h2>
            <p className="text-gray-500 text-[1.0625rem] leading-[1.75] max-w-2xl mx-auto">康永生技は明確で透明性の高い提携フローを提供。安心してお任せいただき、スムーズな市場投入を実現します。</p>
          </div>
          <div className="relative">
            <div className="hidden lg:block absolute top-10 left-[10%] right-[10%] h-0.5 bg-green-100 z-0" />
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 relative z-10">
              {processSteps.map((s, idx) => (
                <div key={s.step} className="flex flex-col items-center text-center">
                  <div className="relative mb-5">
                    <div className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-full bg-white border-2 border-[#4CAF50]">
                      <i className={`${s.icon} text-[#4CAF50] text-2xl`} />
                    </div>
                    <span className="absolute -top-2 -right-2 w-6 h-6 flex items-center justify-center bg-[#4CAF50] text-white text-[0.6875rem] font-bold rounded-full">{idx + 1}</span>
                  </div>
                  <h3 className="text-[#1a2e1a] font-bold text-[1.0625rem] mb-2">{s.title}</h3>
                  <p className="text-gray-500 text-[0.875rem] leading-[1.75]">{s.desc}</p>
                </div>
              ))}
            </div>
          </div>
          <div className="text-center mt-12">
            <Link to="/ja/partnership" className="whitespace-nowrap inline-flex items-center gap-2 bg-[#4CAF50] hover:bg-[#43a047] text-white font-semibold text-[1rem] px-8 py-4 rounded-full transition-all duration-300 cursor-pointer">
              提携の詳細を見る <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20 bg-white">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
          <div className="text-center mb-14">
            <span className="inline-block bg-green-50 text-[#4CAF50] text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-4 border border-green-200">お客様の声</span>
            <h2 className="text-[#1a2e1a] font-bold text-[1.875rem] md:text-[2.25rem] mb-4">康永を選んだブランド</h2>
            <p className="text-gray-500 text-[1.0625rem] leading-[1.75] max-w-2xl mx-auto">250以上のブランドから信頼される実績が、私たちの誇りです。</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {testimonials.map((t, idx) => (
              <div key={idx} className="bg-[#f7faf7] rounded-2xl p-7 border border-gray-100 hover:border-green-200 transition-all duration-300">
                <div className="flex gap-1 mb-5">
                  {Array.from({ length: t.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-[#FFCA28] text-base" />
                  ))}
                </div>
                <p className="text-gray-600 text-[0.9375rem] leading-[1.75] mb-6 italic">&ldquo;{t.quote}&rdquo;</p>
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                    <img src={t.avatar} alt={t.name} className="w-full h-full object-cover object-top" />
                  </div>
                  <div>
                    <p className="text-[#1a2e1a] font-semibold text-[0.9375rem]">{t.name}</p>
                    <p className="text-gray-400 text-[0.8125rem]">{t.company}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-20 bg-[#f7faf7]">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
          <div className="flex flex-col lg:flex-row gap-14 lg:gap-20 items-start">
            <div className="w-full lg:w-1/3 flex-shrink-0">
              <span className="inline-block bg-green-50 text-[#4CAF50] text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-5 border border-green-200">よくある質問</span>
              <h2 className="text-[#1a2e1a] font-bold text-[1.875rem] md:text-[2.25rem] leading-tight mb-6">よくいただくご質問</h2>
              <p className="text-gray-500 text-[1.0625rem] leading-[1.75] mb-8">お探しの情報が見つからない場合は、担当チームに直接お問い合わせください。</p>
              <Link to="/ja/contact" className="whitespace-nowrap inline-flex items-center gap-2 border border-[#4CAF50] text-[#4CAF50] hover:bg-[#4CAF50] hover:text-white font-semibold text-[0.9375rem] px-6 py-3 rounded-full transition-all duration-300 cursor-pointer">
                お問い合わせ <i className="ri-arrow-right-line" />
              </Link>
            </div>
            <div className="w-full lg:w-2/3">
              <div className="space-y-3">
                {faqs.map((faq, idx) => (
                  <div key={idx} className={`bg-white rounded-xl border transition-all duration-200 overflow-hidden ${openFaq === idx ? 'border-[#4CAF50]/40' : 'border-gray-100'}`}>
                    <button className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer" onClick={() => setOpenFaq(openFaq === idx ? null : idx)}>
                      <span className={`text-[1rem] font-semibold leading-snug pr-4 ${openFaq === idx ? 'text-[#4CAF50]' : 'text-[#1a2e1a]'}`}>{faq.q}</span>
                      <div className={`w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-200 ${openFaq === idx ? 'bg-[#4CAF50] text-white' : 'bg-green-50 text-[#4CAF50]'}`}>
                        <i className={`text-sm transition-transform duration-200 ${openFaq === idx ? 'ri-subtract-line' : 'ri-add-line'}`} />
                      </div>
                    </button>
                    {openFaq === idx && (
                      <div className="px-6 pb-5">
                        <p className="text-gray-600 text-[0.9375rem] leading-[1.75]">{faq.a}</p>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Banner */}
      <section className="relative py-20 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=lush%20tropical%20green%20forest%20leaves%20background%20with%20soft%20sunlight%20bokeh%20effect%2C%20vibrant%20emerald%20green%20nature%20scene%2C%20botanical%20garden%20aesthetic%2C%20health%20wellness%20brand%20background%2C%20rich%20green%20tones&width=1920&height=600&seq=cta-banner-bg-01&orientation=landscape"
            alt="CTA 背景"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-[#2d5a2d]/80" />
        </div>
        <div className="relative z-10 max-w-screen-xl mx-auto px-6 lg:px-10">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-10">
            <div className="text-center lg:text-left w-full lg:w-auto">
              <h2 className="text-white font-bold text-[1.875rem] md:text-[2.25rem] leading-tight mb-4">ブランド製造の旅を始める準備はできていますか？</h2>
              <p className="text-green-200 text-[1.0625rem] leading-[1.75] max-w-xl">康永生技の専門チームにお問い合わせください。ブランドのビジョンを実現する最適なOEM/ODMソリューションをご提案します。</p>
            </div>
            <div className="flex flex-col sm:flex-row gap-4 flex-shrink-0 w-full lg:w-auto">
              <Link to="/ja/contact/form" className="whitespace-nowrap bg-white text-[#2d5a2d] hover:bg-green-50 font-bold text-[1.0625rem] px-8 py-4 rounded-full transition-all duration-300 cursor-pointer text-center">
                今すぐお問い合わせ
              </Link>
              <Link to="/ja/services" className="whitespace-nowrap bg-transparent border-2 border-white text-white hover:bg-white/10 font-semibold text-[1.0625rem] px-8 py-4 rounded-full transition-all duration-300 cursor-pointer text-center">
                サービスを見る
              </Link>
            </div>
          </div>
          <div className="mt-12 pt-10 border-t border-white/20 grid grid-cols-2 sm:grid-cols-4 gap-4 sm:gap-6">
            {[
              { icon: 'ri-shield-check-line', text: 'HACCP認定工場' },
              { icon: 'ri-award-line', text: 'ISO品質認証' },
              { icon: 'ri-global-line', text: '専門代工サービス' },
              { icon: 'ri-customer-service-2-line', text: '専任担当サポート' },
            ].map((badge) => (
              <div key={badge.text} className="flex items-center justify-center gap-2 sm:gap-3">
                <div className="w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center flex-shrink-0">
                  <i className={`${badge.icon} text-green-300 text-lg sm:text-xl`} />
                </div>
                <span className="text-white font-medium text-[0.875rem] sm:text-[0.9375rem] whitespace-nowrap">{badge.text}</span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </JaLayout>
  );
}
